var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lowie"},[_vm._v("\n  对不起，您的浏览器版本过低，为了更好的体验，请升级你的浏览器"),_c('br'),_vm._v("\n  推荐您使用Chrome(谷歌)浏览器或者浏览器选择极速模式\n")])}]

export { render, staticRenderFns }